import { Breadcrumbs as BreadcrumbsOriginal } from "@/components/ui-kit/untitled/application/breadcrumbs/breadcrumbs"
import type { BreadcrumbType } from "@/components/ui-kit/untitled/application/breadcrumbs/breadcrumbs"
import { useBreadcrumb } from "@/hooks/use-breadcrumb"
import { cn } from "@/lib/utils"

interface BreadcrumbsProps {
  divider?: "chevron" | "slash"
  type?: BreadcrumbType
  className?: string
  maxVisibleItems?: number
  placeholder?: string
}

/* A flag for start truncating text by checking with index of Breadcrumb's item */
const TRUNCATE_FROM = 2
/* CSS of width resolutions */
const TRUNCATE_WIDTHS = `truncate 
  max-w-[6rem] 
  xxs:max-w-[8rem] 
  xs:max-w-[11rem] 
  md:max-w-[14rem] 
  lg:max-w-[18rem] 
  xl:max-w-[24rem]
`

export function Breadcrumbs(breadcrumbsProps: BreadcrumbsProps) {
  const segments = useBreadcrumb()

  return (
    <BreadcrumbsOriginal
      type={breadcrumbsProps.type ?? "button"}
      maxVisibleItems={breadcrumbsProps.maxVisibleItems ?? 3}
      {...breadcrumbsProps}
      className="w-full overflow-x-clip"
    >
      {segments.map((seg, i) => (
        <BreadcrumbsOriginal.Item key={i} href={seg.href} icon={seg.icon}>
          <span className={cn("block", i >= TRUNCATE_FROM && TRUNCATE_WIDTHS)}>
            {seg.label}
          </span>
        </BreadcrumbsOriginal.Item>
      ))}
      {breadcrumbsProps.placeholder && (
        <BreadcrumbsOriginal.Item
          key={`${breadcrumbsProps.placeholder}`}
          href={`#${breadcrumbsProps.placeholder.toLowerCase().replace(/ /g, "-")}`}
        >
          <span className={cn("block", TRUNCATE_WIDTHS)}>
            {breadcrumbsProps.placeholder}
          </span>
        </BreadcrumbsOriginal.Item>
      )}
    </BreadcrumbsOriginal>
  )
}
